import { api } from './api';

export interface LoginResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  username: string;
  role: string;
  must_change_password: boolean;
}

export const authApi = {
  login: (username: string, password: string) =>
    api.post<LoginResponse>('/auth/login', { username, password }),
  me: () => api.get<{ username: string }>('/auth/me'),
  changePassword: (current_password: string, new_password: string) =>
    api.post<{ status: string }>('/auth/change-password', {
      current_password,
      new_password,
    }),
};

export interface UserRow {
  id: string;
  email: string;
  nome: string;
  role: 'editor' | 'admin' | string;
  is_active: boolean;
  must_change_password: boolean;
  created_at: string;
}

export const usersApi = {
  list: () => api.get<UserRow[]>('/users'),
  create: (nome: string, email: string, role: string) =>
    api.post<UserRow>('/users', { nome, email, role }),
  patch: (id: string, patch: Partial<Pick<UserRow, 'nome' | 'role' | 'is_active'>>) =>
    api.patch<UserRow>(`/users/${id}`, patch),
  resetPassword: (id: string) =>
    api.post<{ status: string; temp_password: string }>(`/users/${id}/reset-password`, {}),
};
